import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { vibrate } from '../utils/haptics';
import CollectibleIcon from './CollectibleIcon';
import type { CollectibleDef } from '../utils/collectibles';
import './CollectibleUnlockedAnimation.css';

interface CollectibleUnlockedAnimationProps {
  collectible: CollectibleDef | null;
  onClose: () => void;
}

const CollectibleUnlockedAnimation: React.FC<CollectibleUnlockedAnimationProps> = ({ collectible, onClose }) => {
  const { t } = useTranslation();

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!collectible) return;
    vibrate('collectible');
    const timer = setTimeout(() => onCloseRef.current(), 5000);
    return () => clearTimeout(timer);
  }, [collectible]);

  if (!collectible) return null;

  return ReactDOM.createPortal(
    <div className="cu-backdrop" onClick={onClose}>
      <div className="cu-modal" key={collectible.id} onClick={e => e.stopPropagation()}>
        <div className="cu-badge">{t('collectibleUnlocked.badge')}</div>
        <div className="cu-icon">
          <CollectibleIcon path={collectible.icon} className="cu-icon__svg" />
        </div>
        <div className="cu-name">{collectible.name}</div>
        <div className="cu-desc">{collectible.desc}</div>
        <button className="cu-button" onClick={onClose}>{t('collectibleUnlocked.button')}</button>
      </div>
    </div>,
    document.body
  );
};

export default CollectibleUnlockedAnimation;
